/* eslint camelcase: "off" */
import React from "react"
import PropTypes from "prop-types"
import { FormContainer, InputField, StandardModal, LabeledInput } from "uikit"
import { Grid, Form, Select } from "semantic-ui-react"
import { carPropertySchema } from "components/properties/carPropertySchema"

const CarForm = ({
  data: {
    fields: { description, value, model_year },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Add Car",
  submitHeader = "",
  onCancel,
  askIfPrimaryResidence
}) => {
  let currentYear = new Date().getFullYear()
  let yearOptions = [...Array(31).keys()].map(key => {
    let year = currentYear - key + ""
    return { text: year, value: year }
  })
  return (
    <Form
      error={hasError}
      loading={isPending}
      className="AddModal__Form"
      onSubmit={onSubmit}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <InputField
              autoFocus
              field={description}
              label="Car Name"
              className="AddModal__FormField"
            />
            <InputField
              field={value}
              label="Current estimated trade-in/sale value"
              className="AddModal__FormField LabeledInput"
              control={LabeledInput}
              iconText="$"
              iconPosition="left"
              placeholder="Trade-in/sale value"
              textPosition="left"
            />
            <InputField
              field={model_year}
              className="AddModal__FormField"
              placeholder="Model year of the car"
              label="Model year"
              fluid
              selection
              control={Select}
              options={yearOptions}
              search={(options, query) => {
                return options.filter(option =>
                  option.text.toLowerCase().startsWith(query.toLowerCase())
                )
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <button type="submit" style={{ display: "none" }} />
    </Form>
  )
}

const AddCarFormModal = props => (
  <StandardModal defaultOpen={true} closeOnDimmerClick={false}>
    <StandardModal.Header header="Add Car" />
    <StandardModal.Content>
      <CarForm {...props} />
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Add Car"
      cancelLabel="Cancel"
      onSubmit={props.data.onSubmit}
      onCancel={props.onCancel}
      loading={props.data.isPending}
    />
  </StandardModal>
)

export const AddCarModal = FormContainer(carPropertySchema)(AddCarFormModal)

AddCarModal.PropTypes = {
  submit: PropTypes.func,
  onCancel: PropTypes.func
}
